<template>
  <div>
    <b-container fluid class="" id="relatedArticleAuthor">
      <!-- needs to be here for relations/connections reasons??? -->
      <div class="hide-always">{{ authorId }}</div>
      
      <b-row class="article-container" v-for="relAut in entries" :key="relAut.uid">
        <b-col cols="12" md="6" class="field-rubriken">
          <div class="tag-rubriken">
            <p>{{ relAut.artikelRubriken }}</p>
            <p></p>
        </div>
        </b-col>
        <b-col cols="12" md="3" class="field-autor">
          <template v-for="rel in relAut.artikelAutor">
          <h3 class="bigger font-color-red" :key="rel.uid">
            {{ rel.title }}
          </h3>
          </template>
        </b-col>
        <b-col cols="12" md="3" class="field-ausgabe-nr">
          <template v-for="rel in relAut.artikelAusgabeNr">
          <h3 class="bigger" :key="rel.uid">
            <router-link :to="'/ausgabe/' + rel.slug" class="normallink autor-ausgabe-link">
              {{ rel.title }}
              <svg class="autor-ausgabe-icon" height="17px" style="enable-background:new 0 0 12 12;" version="1.1" viewbox="0 0 12 12" width="17px" x="0px" xml:space="preserve" y="0px"><title>link-desktop</title><polygon points="3.5,0 3.5,1.5 9.4,1.5 0,11 1,12 10.5,2.6 10.5,8.5 12,8.5 12,0 "/></svg>
            </router-link>
          </h3>
          </template>
        </b-col>
        <b-col cols="12" class="field-article-titel">
          <h3 class="bigger" @click="onAccordionClicked">
          {{ relAut.title }}
        </h3>
        </b-col>

        <b-col cols="12"  class="field-article-abstract">
          <p>
            {{ relAut.artikelAbstract }}
          </p>
          <div class="field-schlagworte">
            <div class="tag-schlagworte" v-for="rel in relAut.schlagwort3" :key="rel.uid">
              <p>{{ rel.title }}</p>
            </div>
          </div>
        </b-col>

        <b-col cols="12" class="field-article-icons" id="article-icons">
          <a class="icon-link normallink" @click="onAccordionClicked" v-if="relAut.artikelAbstract">
          <div class="icons">
            <svg class="hide-mobile" height="13px" id="Ebene_1" style="enable-background:new 0 0 26 12;" version="1.1" viewbox="0 0 26 12" width="27px" x="0px" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px"><title>abstract-desktop</title><g><circle cx="13" cy="6" r="1.6"/><path d="M25.4,5.5C21.2,2.1,17.1,0.4,13,0.4c-4.1,0-8.3,1.7-12.4,5.1L0,6l0.6,0.5c4.1,3.4,8.3,5.1,12.4,5.1c4.1,0,8.3-1.7,12.4-5.1 L26,6L25.4,5.5z M13,9.9c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9S15.1,9.9,13,9.9z M9.8,2C8.6,3,7.9,4.4,7.9,6 c0,1.6,0.8,3,1.9,4C7.2,9.4,4.6,8.1,2,6C4.6,3.9,7.2,2.6,9.8,2z M16.2,10c1.2-0.9,1.9-2.4,1.9-4c0-1.6-0.8-3-1.9-4 C18.8,2.6,21.4,4,24,6C21.4,8.1,18.8,9.4,16.2,10z"/></g></svg>
            <p class="icon-description inline-block hide-mobile">Abstract</p>
            <svg class="hide-desktop" height="17px" version="1.1" viewbox="0 0 37 17" width="37px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><title>abstract-mobile</title><g fill-rule="evenodd" fill="none" id="icon-/vorschau-/black-copy" stroke-width="1" stroke="none"><circle cx="18.5" cy="7.5" id="Oval" r="5.5" stroke-width="2" stroke="#000000"></circle><circle cx="19" cy="8" id="Oval" r="1" stroke-width="2" stroke="#000000"></circle><path d="M33,8 C28.0950217,4 23.2612284,2 18.49862,2 C13.677498,2 8.84462467,4 4,8 C8.83201438,12 13.6648877,14 18.49862,14 C23.3323523,14 28.1661456,12 33,8 Z" id="Path-3" stroke-width="2" stroke="#000000"></path></g></svg>
          </div>
        </a>

          <a :href="relAut.artikelPdf[0].url" target="_blank" class="icon-link normallink" v-if="relAut.artikelPdf.length">
            <div class="icons">
              <svg class="hide-mobile" height="12px" id="Ebene_1" style="enable-background:new 0 0 12 12;" version="1.1" viewbox="0 0 12 12" width="12px" x="0px" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px"><title>download-1-desktop</title><polygon points="12,10.5 7.5,10.5 12,6 10.9,4.9 6.8,9.1 6.8,0 5.2,0 5.2,9.2 1,4.9 0,6 4.5,10.5 0,10.5 0,12 6,12 6,12 6,12 12,12"/></svg>
              <p class="icon-description inline-block hide-mobile">Einzelbeitrag PDF</p>
              <svg class="hide-desktop" height="17px" version="1.1" viewbox="0 0 37 17" width="37px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><title>download-1-mobile</title><g fill-rule="evenodd" fill="none" id="icon-/download-/black-copy-3" stroke-width="1" stroke="none"><polyline id="Rectangle" points="12.5 0.485281374 24.5 0.485281374 24.5 12.4852814" stroke-width="2" stroke="#000000" transform="translate(18.500000, 6.485281) rotate(135.000000) translate(-18.500000, -6.485281) "></polyline><path d="M10,16.5 L27,16.5" id="Line-2" stroke-width="2" stroke="#000000"></path><path d="M10,8.5 L27,8.5" id="Line-2-Copy" stroke-width="2" stroke="#000000" transform="translate(18.500000, 8.500000) rotate(90.000000) translate(-18.500000, -8.500000) "></path></g></svg>
            </div>
          </a>

          <a :href="relAut.heftPdf[0].url" target="_blank" class="icon-link normallink" v-if="relAut.heftPdf.length">
            <div class="icons">
              <svg class="hide-mobile" height="12px" id="Ebene_1" style="enable-background:new 0 0 12 12;" version="1.1" viewbox="0 0 12 12" width="12px" x="0px" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px"><title>download-total-desktop</title><polygon points="12,10.5 7.5,10.5 12,6 10.9,4.9 6.8,9.1 6.8,8 12,2.8 10.9,1.7 6.8,5.9 6.8,0 5.2,0 5.2,5.9 1,1.7 0,2.8 5.2,8 5.2,9.2 1,4.9 0,6 4.5,10.5 0,10.5 0,12 6,12 6,12 6,12 12,12 "/></svg>
              <p class="icon-description inline-block hide-mobile">Heft PDF</p>
              <svg class="hide-desktop" height="17px" version="1.1" viewbox="0 0 37 17" width="37px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><title>download-all-mobile</title><g fill-rule="evenodd" fill="none" id="icon-/download-all-/black-copy" stroke-width="1" stroke="none"><polyline id="Rectangle" points="12.5 0.485281374 24.5 0.485281374 24.5 12.4852814" stroke-width="2" stroke="#000000" transform="translate(18.500000, 6.485281) rotate(135.000000) translate(-18.500000, -6.485281) "></polyline><polyline id="Rectangle-Copy" points="12.5 -4.31471863 24.5 -4.31471863 24.5 7.68528137" stroke-width="2" stroke="#000000" transform="translate(18.500000, 1.685281) rotate(135.000000) translate(-18.500000, -1.685281) "></polyline><path d="M10,16.5 L27,16.5" id="Line-2" stroke-width="2" stroke="#000000"></path><path d="M10,8.5 L27,8.5" id="Line-2-Copy" stroke-width="2" stroke="#000000" transform="translate(18.500000, 8.500000) rotate(90.000000) translate(-18.500000, -8.500000) "></path></g></svg>
            </div>
          </a>

          <a :href="relAut.linkArtikelKaufen" target="_blank" class="icon-link normallink" v-if="relAut.linkArtikelKaufen">
            <div class="icons">
              <svg class="hide-mobile" height="12px" id="Ebene_1" style="enable-background:new 0 0 12 12;" version="1.1" viewbox="0 0 12 12" width="12px" x="0px" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px"><title>link-desktop</title><polygon points="3.5,0 3.5,1.5 9.4,1.5 0,11 1,12 10.5,2.6 10.5,8.5 12,8.5 12,0 "/></svg>
              <p class="icon-description inline-block hide-mobile">Artikel bestellen</p>
              <svg class="hide-desktop" height="17px" version="1.1" viewbox="0 0 37 17" width="37px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><title>link-mobile</title><g fill-rule="evenodd" fill="none" id="icon-/link-/black-copy-10" stroke-width="1" stroke="none"><path d="M26.3045372,0.695462751 L11,16" id="Path-2" stroke-width="2" stroke="#000000"></path><polyline id="Rectangle" points="14 1 26 1 26 13" stroke-width="2" stroke="#000000"></polyline></g></svg>
            </div>
          </a>

          <a :href="relAut.linkHeftKaufen" target="_blank" class="icon-link normallink" v-if="relAut.linkHeftKaufen">
            <div class="icons">
              <svg class="hide-mobile" height="12px" id="Ebene_1" style="enable-background:new 0 0 12 12;" version="1.1" viewbox="0 0 12 12" width="12px" x="0px" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" y="0px"><title>link-desktop</title><polygon points="3.5,0 3.5,1.5 9.4,1.5 0,11 1,12 10.5,2.6 10.5,8.5 12,8.5 12,0 "/>
              </svg>
              <p class="icon-description inline-block hide-mobile">Heft bestellen</p>
              <svg class="hide-desktop" height="17px" version="1.1" viewbox="0 0 37 17" width="37px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><title>link-mobile</title><g fill-rule="evenodd" fill="none" id="icon-/link-/black-copy-10" stroke-width="1" stroke="none"><path d="M26.3045372,0.695462751 L11,16" id="Path-2" stroke-width="2" stroke="#000000"></path><polyline id="Rectangle" points="14 1 26 1 26 13" stroke-width="2" stroke="#000000"></polyline></g></svg>
            </div>
          </a>


        </b-col>
      </b-row>
    </b-container>
  </div>
    
</template>

<script>
const axios = require("axios");

export default {
  name: "navigation",
  components: {
    //Navigation
  },
  props: {
    navigationPlaceholder: String,
    authorId: String
  },
  data() {
    return {
      entries: [],
    };
  },
  updated() {
    console.log("mounted" + this.authorId);
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                 entries(section: "archiv", relatedTo: "` + this.authorId +`" ){
                    title,
                    uid,
                    ... on archiv_archiv_Entry{
                      artikelRubriken (label: true),
                      artikelAusgabeNr {
                        title,
                        url,
                        slug,
                        id
                      },
                      artikelAutor {
                        title,
                        url,
                        slug,
                        id, 
                        uid
                      },
                      artikelAbstract,
                    	artikelPdf {
                    	  url
                      },
                    	heftPdf {
                    	  url
                      },
                    	linkArtikelKaufen,
                    	linkHeftKaufen,
                    	schlagwort3 {
                    	  title,
                        uid
                    	},
                    }
                  }
               }
             `,
      },
    })
    .then((result) => {
      //console.log(result);
      let data = result.data.data.entries;
      //console.log(data);

      // assign the fetched data 2 times, once for manipulation
      // once for reseting
      this.entries = data;
      this.entriesToManipulate = data;
    });
  },
  mounted() {},
  methods: { 
    onAccordionClicked(event){
      let element = event.currentTarget.parentElement.parentElement;
      let articleIcons = event.currentTarget.parentElement.parentElement.lastElementChild;

      element.classList.toggle("open");
      articleIcons.classList.toggle("article-icons-show");
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/master.scss";
</style>













